
























































































































import { mapGetters } from 'vuex';

export default {
    name: 'Sidebar',

    setup() {
        const collapsed = ref<boolean>(false);
        const showCreateOptionsModal = ref<boolean>(false);

        let sidebarItems = [
            {
                text: 'Dashboard',
                link: '/',
                icon: 'pie-chart-icon',
            },
            {
                text: 'Job Posts',
                link: 'jobs',
                icon: 'briefcase-icon.svg',
            },
            {
                text: 'Bursaries',
                link: 'bursaries',
                icon: 'academic-cap.svg',
            },
            {
                text: 'Applicants',
                link: 'applicants',
                icon: 'user-group-icon.svg',
            },
            {
                text: 'Prospects',
                link: 'prospects',
                icon: 'star-icon.svg',
            },
            {
                text: 'Placements',
                link: 'placements',
                icon: 'clipboard-check-icon.svg',
            },
            {
                text: 'Head Hunting',
                link: 'head-hunting',
                icon: 'search-icon.svg',
            },
            {
                text: 'Interviews',
                link: 'interviews',
                path: '/interviews/upcoming',
                icon: 'calendar-solid.svg',
            },
        ];

        if (process.env.BILLING_ENABLED === 'true') {
            const billing = {
                text: 'Billing',
                link: 'billing',
                icon: 'credit-card-icon.svg',
            };

            sidebarItems = [...sidebarItems, billing];
        }

        return {
            collapsed,
            sidebarItems,
            showCreateOptionsModal,
        };
    },

    computed: {
        ...mapGetters({
            theme: 'getTheme',
            companyDetails: 'getCompanyDetails',
            collapseSidebar: 'getCollapseSidebar',
        }),

        ...mapGetters('notifications/notifications', {
            unReadNotifications: 'getUnreadBoolean',
        }),

        hasUnreadMessages() {
            return this.$store.getters['conversations/getHasUnreadMessages'];
        },
    },

    created() {
        this.getUnread();

        if (!this.collapseSidebar) {
            this.collapsed = localStorage.getItem('sidebar-collapsed') === 'true' || false;
        }
    },

    watch: {
        unReadNotifications: function () {
            this.getUnread();
        },

        collapseSidebar(value) {
            if (!this.collapseSidebar) {
                this.collapsed = localStorage.getItem('sidebar-collapsed') === 'true' || false;
            } else {
                this.collapsed = true;
            }
        },
    },

    mounted() {
        this.initEcho();
    },

    beforeDestroy() {
        if (!this.$auth.user.company) return;

        this.$echo.leave(`companies.${this.$auth.user.company.uuid}.conversations`);
    },

    methods: {
        initEcho() {
            if (!this.$auth.user.company) return;

            this.$echo.private(`companies.${this.$auth.user.company.uuid}.conversations`).listen('.company.conversation.updated', () => {
                this.$store.dispatch('conversations/setHasUnreadMessages', true);
            });
        },

        toggleSidebar() {
            this.collapsed = !this.collapsed;
            localStorage.setItem('sidebar-collapsed', this.collapsed);
        },

        async logout() {
            await this.$store.dispatch('company/login/logout').then((response) => {
                this.$toast.show({
                    type: 'success',
                    message: 'Successfully logged out!',
                });
            });
        },

        async getUnread() {
            await this.$store.dispatch('notifications/notifications/checkForUnread');
        },
    },
};
